module.exports = __webpack_public_path__ + "img/auth-certificate-bg-v2.6982bcdb.png";